import { render } from "./ContactComp.vue?vue&type=template&id=8655abec&scoped=true"
import script from "./ContactComp.vue?vue&type=script&lang=js"
export * from "./ContactComp.vue?vue&type=script&lang=js"

import "./ContactComp.vue?vue&type=style&index=0&id=8655abec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8655abec"]])

export default __exports__